import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import styles from './Members.module.scss';
const Members = ({ guildInfoData }) => {
    return (_jsxs("div", Object.assign({ className: cn(styles.element, 'd-flex') }, { children: [_jsx("div", { children: (guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.memberCount) || '0' }), _jsx(Paragraph, { size: 1, color: 'grey', title: `/${(guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.maxMembers) || '0'}` })] })));
};
export default Members;
